export default {
      id: "download-usage",
      viewBox: "44.998 19.971 110.004 160.059",
      url: __webpack_public_path__ + "img/icons.28944b68.svg#download",
      toString: function () {
        return this.url;
      }
    }